import type { UserManagerSettings } from "oidc-client-ts";
import { env } from "@/env";

export const oidcConfig: UserManagerSettings = {
  authority: env.oidcAuthority,
  client_id: env.oidcClientId,
  redirect_uri: `${env.appUrl}/auth/callback`,
  response_type: "code",
  scope: "openid profile",
  post_logout_redirect_uri: `${env.appUrl}/auth/logout`,
  resource: `api://${env.oidcClientId}`,
  loadUserInfo: true,
  automaticSilentRenew: true,
};
